import { css } from '@emotion/react';
import { bpoints } from '../../Utils';

export function cotizadorCSS() {
    return css`

        color: #2e373b;
        display: flex;
        flex-direction: column;
        min-height: 100vh;

        .loader {
            background-color: #5f5f5f4a;
            display: block;
            width: 100vw;
            height: 100vh;
            position: fixed;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 3;
            /* backdrop-filter: blur(4px); */
            /* backdrop-filter: blur(1px); */
            /* transform: translate3d(0, 0, 0); */

            span {
                //animation: rotation 1000ms infinite linear;
                img{
                    width: 200px;
                }
                animation: pulse 1.5s infinite;
            }

            @keyframes rotation {
                0% {
                    transform: rotate(0deg) scale(0);
                }

                25% {
                    transform: rotate(360deg) scale(2);
                }

                50% {
                    transform: rotate(1080deg) scale(2);
                }

                75% {
                    transform: rotate(360deg) scale(2);
                }

                100% {
                    transform: rotate(0deg) scale(0);
                }
            }

            @keyframes pulse {
                0% {
                    transform: scale(0.7);
                    //box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
                }

                70% {
                    transform: scale(1);
                    //box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
                }

                100% {
                    transform: scale(0.7);
                    //box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
                }
            }
        }

        .Dropdown{
            background-color: transparent;
            border-radius: 17px;
            border-color: #34C6F1;
            border-width: 1.5px;
            width: 100%;
            
            .p-inputtext{
                padding: 1rem 1.4rem;
                letter-spacing: 0.46px;
            }
            input{
                background-color: transparent;
                width: 100%;
                padding: 1rem 1.4rem;
                font-family: 'Neue Haas Grotesk Display Pro' !important;
                font-style: normal;
                font-weight: 600;
                letter-spacing: 0.46px;
                color: black;
            }

            .p-placeholder{
                color: #A7A9AC;
                font-weight: 500;
            }

            *{

                font-family: 'Neue Haas Grotesk Display Pro' !important;
                font-size: calc(0.2rem + 0.7vw);

                @media (max-width: ${bpoints.tablet.w}px){
                    font-size: calc(0.8rem + 1vw);
                }
            }
        }

         .DropdownError{
            background-color: transparent;
            border-radius: 17px;
            border-color: #ff0000;
            border-width: 1.5px;
            text-transform: uppercase;
            width: 100%;
             font-weight: 500;
            
            .p-inputtext{
                padding: 1rem 1.4rem;
                letter-spacing: 0.46px;
            }

            .p-placeholder{
                color: #A7A9AC;
                font-weight: 500;
            }

            *{

                font-family: 'Neue Haas Grotesk Display Pro' !important;
                font-size: calc(0.2rem + 0.7vw);

                @media (max-width: ${bpoints.tablet.w}px){
                    font-size: calc(0.8rem + 1vw);
                }
            }
        }

        .p-inputwrapper-filled{
            font-weight: 600;
            color: black;
        }

        .p-calendar{
            .p-inputtext{
                background-color: transparent;
                border-radius: 17px 0 0 17px ;
                border-color: #34C6F1;
                border-width: 1.5px;
                //width: 100%;
                padding: 1rem 1.4rem;

                font-family: 'Neue Haas Grotesk Display Pro' !important;
                font-size: calc(0.2rem + 0.7vw);
                font-style: normal;
                font-weight: 600;
                letter-spacing: 0.46px;
                color: black;
                
                @media (max-width: ${bpoints.tablet.w}px){
                    font-size: calc(0.8rem + 1vw);
                }
                
                ::placeholder{
                    font-weight: 500;
                    color: #A7A9AC;
                }

            }
        }

        .TextInput{
            background-color: transparent;
            border-radius: 17px;
            border-color: #34C6F1;
            border-width: 1.5px;
            width: 100%;
            padding: 1rem 1.4rem;

            font-family: 'Neue Haas Grotesk Display Pro' !important;
            font-size: calc(0.2rem + 0.7vw);
            font-style: normal;
            font-weight: 600;
            letter-spacing: 0.46px;
            color: black;
            
            @media (max-width: ${bpoints.tablet.w}px){
                font-size: calc(0.8rem + 1vw);
            }

            ::placeholder{
                font-weight: 500;
                color: #A7A9AC;
            }

        }
        .TextInputError{
            border-color: #ff0000;  
             background-color: transparent;
            border-radius: 17px;
            border-width: 1.5px;
            width: 100%;
            padding: 1rem 1.4rem;

            font-family: 'Neue Haas Grotesk Display Pro' !important;
            font-size: calc(0.2rem + 0.7vw);
            font-style: normal;
            font-weight: 600;
            letter-spacing: 0.46px;
            color: black;
            
            @media (max-width: ${bpoints.tablet.w}px){
                font-size: calc(0.8rem + 1vw);
            }

            ::placeholder{
                font-weight: 500;
                color: #A7A9AC;
            }

        }

        
        

        

        .DivPDF{
            background-color: #2e373b;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100vh;

            iframe{
                width: 100%;
                height: 100%;
            }
        }


        .Button{
            display: inline-block;
            outline: none;
            cursor: pointer;
            font-size: 14px;
            line-height: 20px;
            font-weight: 600;
            border-radius: 8px;
            padding: 10px 18px;
            border: 1px solid #222222;
            transition: box-shadow 0.2s ease 0s, -ms-transform 0.1s ease 0s, -webkit-transform 0.1s ease 0s, transform 0.1s ease 0s;
            background: #fff;
            color: #222222;
            :hover {
                border-color: #000000;
                background: #f7f7f7;
            }
                  
        }

        .PdfButtonContainer{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-bottom: 0.7rem;

        }


        .StepsContainer{
            position: relative;
            overflow-x: hidden;
            flex-grow: 1;
            display: flex;
            flex-direction: column;

            /* ::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 60%;
                background: linear-gradient(to bottom, rgba(52, 198, 241, 0.05), white);
            } */

            ::after {
                content: "";
                position: absolute;
                z-index: -1;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 40%;
                background: linear-gradient(180deg, rgba(50, 184, 223, 0.00) 0%, rgba(50, 184, 223, 0.15) 100%);
            }
        }
    `;
}